<template>
    <v-menu
        v-model="show"
        :position-x ="68"
        :position-y="272"
        absolute
        offset-y
        nudge-top="-4"
        min-width="250"
        @input  = "onInput"
    >
        <div class="history-title primary white--text">
           {{ $t('unit.tzb.reports') }}
        </div>
        <v-list>
            <v-list-item
                v-for  = "(item, index) in menu"
                :key   = "index"
                @click = "onSelected(item)"
            >
                <div class="v-flex">
                    <div >
                        {{ item.name }}
                    </div>
                </div>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>

export default {
    name: "PSiteTzbReports",

    props: {
        value: {

        },

        menu: {

        },
    },

    data: () => ({
        show: false,
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.show = this.value;
        },
    },

    methods: {
        onInput () {
            if (!this.show) {
                this.$emit("input", false)
            }
        },

        onSelected (item) {
            this.$emit("selected", item);
        },
    }
}
</script>

<style scoped>

.history-title {
    height: 32px;
    padding-left: 8px;
    padding-top: 4px;
    font-size: 16px;
}

.history-date {
    width: 120px;
}

:deep(.v-list-item) {
    min-height: 40px;
}

</style>